import {
  ListKlassesFilters,
  getKlass,
  listKlasses,
  listKlassesPerformanceSummary,
  listKlassesPendingSummary,
} from '@/data/services/klassServices';

export const klassQueries = {
  all: ['klasses'] as const,

  get: (id: number) => ({
    queryKey: [...klassQueries.all, 'get', id] as const,
    queryFn: () => getKlass(id),
  }),

  list: (filters: ListKlassesFilters = {}) => ({
    queryKey: [...klassQueries.all, 'list', { filters }] as const,
    queryFn: () => listKlasses(filters),
  }),

  performanceSummaryList: (filters: ListKlassesFilters = {}) => ({
    queryKey: [
      ...klassQueries.all,
      'performance-summary',
      { filters },
    ] as const,
    queryFn: () => listKlassesPerformanceSummary(filters),
  }),
  pendingSummaryList: (filters: ListKlassesFilters = {}) => ({
    queryKey: [...klassQueries.all, 'pendingSummaryList', { filters }] as const,
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      listKlassesPendingSummary({ ...filters, pageNumber: pageParam }),
  }),
};
